import React, { useState } from "react";
import HalloweenImage from "../../../../../../assets/images/about/chris-halloween.jpg";
import WeddingImage from "../../../../../../assets/images/about/wedding.jpg";
import { Letter, letters } from "./data";
import SectionHead from "./SectionHead";

const StoryCard = ({
  image,
  tag,
  title,
  children,
}: {
  image: string;
  tag: string;
  title: string;
  children: React.ReactNode;
}) => (
  <article className="story">
    <div className="story-image">
      <img src={image} alt="" loading="lazy" />
    </div>
    <div className="story-body">
      <span className="story-tag">{tag}</span>
      <h3>{title}</h3>
      <p>{children}</p>
    </div>
  </article>
);

const LetterModal = ({
  letter,
  onClose,
  onAgain,
}: {
  letter: Letter;
  onClose: () => void;
  onAgain: () => void;
}) => (
  <div
    className="lt-modal is-open"
    role="dialog"
    aria-modal="true"
    aria-labelledby="letter-name"
  >
    <article className="lt-letter">
      <header className="lt-letter-head">
        <span className="lt-course-tag">{letter.course}</span>
        <button
          type="button"
          className="lt-close"
          aria-label="Close letter"
          onClick={onClose}
        >
          x
        </button>
      </header>
      <div className="lt-letter-body">
        <span className="lt-quote-mark" aria-hidden="true">
          &ldquo;
        </span>
        <p className="lt-quote">{letter.quote}</p>
        <div className="lt-sign">
          <div className="lt-name" id="letter-name">
            {letter.name}
          </div>
          <div className="lt-meta">{letter.date}</div>
          <div className="lt-verified">
            5-star verified review on 42courses.com
          </div>
        </div>
      </div>
      <footer className="lt-letter-foot">
        <span>Hand-picked from real 42courses reviews</span>
        <button type="button" className="lt-again" onClick={onAgain}>
          Open another
        </button>
      </footer>
    </article>
  </div>
);

const Stories = () => {
  const [letter, setLetter] = useState<Letter | null>(null);
  const openLetter = () =>
    setLetter(letters[Math.floor(Math.random() * letters.length)]);
  return (
    <section className="stories" aria-labelledby="stories-title">
      <div className="wrap">
        <SectionHead
          number="05"
          title="True stories, from"
          emphasis="actual inboxes."
          id="stories-title"
        />
        <div className="story-grid">
          <StoryCard
            image={HalloweenImage}
            tag="Halloween - NYC"
            title="Someone dressed up as Chris for Halloween."
          >
            A member of a team in New York loved our course emails so much she
            came to work as the man who writes them. Megaphone included.
          </StoryCard>
          <StoryCard
            image={WeddingImage}
            tag="Germany"
            title="A Happy Course graduate invited us to her wedding."
          >
            She said the course had helped her relationship so much she wanted
            us there. We did not know you could put that on an About page, but
            here we are.
          </StoryCard>
          <article className="story">
            <button
              type="button"
              className="story-image letter-tile"
              onClick={openLetter}
              aria-haspopup="dialog"
            >
              <span className="envelope" aria-hidden="true">
                <span className="flap"></span>
                <span className="stamp">42</span>
              </span>
              <span className="letter-cta">Open a random letter</span>
            </button>
            <div className="story-body">
              <span className="story-tag">Every week</span>
              <h3>Unprompted letters of thanks.</h3>
              <p>
                Promotions won. Sales increased. Negotiations nailed. Books
                written. Businesses started. Confidence reclaimed.
              </p>
            </div>
          </article>
        </div>
      </div>
      {letter && (
        <LetterModal
          letter={letter}
          onClose={() => setLetter(null)}
          onAgain={openLetter}
        />
      )}
    </section>
  );
};

export default Stories;
